











import {Component, Prop, Vue, Watch} from "vue-property-decorator";

@Component
export default class FlowRelation extends Vue {
  @Prop({
    type: String,
    default() {
      return '';
    }
  })
  value!: string;

  public label = '';

  @Watch('value')
  getLabel(newVal: string) {
    if (newVal === 'AND') {
      this.label = this.$t('components.flow.flow-box.text_4e14') as string;
    } else if (newVal === 'OR') {
      this.label = this.$t('components.flow.flow-box.text_6216') as string;
    } else {
      this.label = '';
    }
  }

  created() {
    this.getLabel(this.value);
  }

}

